/*! @wharfkit/roborovski v4.0.0-rc7 | BSD-3-Clause | Copyright (c) 2023 Greymass Inc. | https://github.com/wharfkit/js */
import { API, Checksum256, Int32, Name, UInt32 } from "@wharfkit/antelope";
//#region src/endpoints.ts
var ActivityCursor = class ActivityCursor {
	constructor(client, account, options, response) {
		this.client = client;
		this.account = account;
		this.options = options;
		this.results = response.results;
		this.next_cursor = response.next_cursor;
		this.prev_cursor = response.prev_cursor;
	}
	async next() {
		if (!this.next_cursor) throw new Error("No next page available");
		return ActivityCursor.fetch(this.client, this.account, {
			...this.options,
			cursor: this.next_cursor
		});
	}
	async prev() {
		if (!this.prev_cursor) throw new Error("No previous page available");
		return ActivityCursor.fetch(this.client, this.account, {
			...this.options,
			cursor: this.prev_cursor
		});
	}
	static async fetch(client, account, options = {}) {
		if (options.action && !options.contract) throw new Error("action filter requires contract to be specified");
		const params = {
			limit: options.limit !== void 0 ? options.limit : 100,
			order: options.order || "desc",
			decode: options.decode !== void 0 ? options.decode : true,
			cursor: options.cursor,
			contract: options.contract,
			action: options.action,
			date: options.date,
			start_date: options.start_date,
			end_date: options.end_date,
			omit_null_fields: options.omit_null_fields
		};
		const response = await client.call({
			path: `/account/${account}/activity`,
			params
		});
		return new ActivityCursor(client, account, options, response);
	}
};
var RoborovskiClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_actions(accountName, options) {
		let reverse = options ? options.reverse : void 0;
		const params = { account_name: Name.from(accountName) };
		if (options) {
			if (options.start !== void 0) params.pos = Int32.from(options.start);
			if (options.limit) params.offset = Int32.from(options.limit);
			if (options.reverse && params.pos) params.pos = Int32.from(params.pos).multiplying(-1);
			if (options.reverse && params.offset) params.offset = Int32.from(params.offset).multiplying(-1);
		} else {
			params.pos = Int32.from(-1);
			params.offset = Int32.from(-100);
			reverse = true;
		}
		const result = await this.client.call({
			path: "/v1/history/get_actions",
			params,
			responseType: API.v1.GetActionsResponse
		});
		if (reverse) result.actions.reverse();
		return result;
	}
	async activity(accountName, options) {
		return ActivityCursor.fetch(this.client, Name.from(accountName), options);
	}
	async transaction(id, options = {}) {
		const txid = Checksum256.from(id);
		return (await this.client.call({
			path: `/transaction/${txid}`,
			params: { traces: options.traces !== void 0 ? options.traces : true }
		})).results;
	}
	async get_transaction(id, options = {}) {
		return this.client.call({
			path: "/v1/history/get_transaction",
			params: {
				id: Checksum256.from(id),
				block_num_hint: options.blockNumHint && UInt32.from(options.blockNumHint),
				traces: options.traces !== void 0 ? options.traces : false
			},
			responseType: API.v1.GetTransactionResponse
		});
	}
};
//#endregion
export { ActivityCursor, RoborovskiClient };

//# sourceMappingURL=roborovski.m.js.map